import React from 'react';
import './Header.scss'
import { Link } from 'react-router-dom'
import SideMenu from './SideMenu';

export class AppHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuList: [
        {
          name: '走进青矩',
          url: '/Introduction',
          ErMenu: [
            { name: '公司简介', url: '/Introduction/CompanyProfile' },
            { name: '青矩生态', url: '/Introduction/Ecology' },
            { name: '社会认可', url: '/Introduction/QualificationAndHonor' }
          ]
        },
        {
          name: '青矩服务',
          url: '/Products',
          ErMenu: [
            {
              name: '全过程工程咨询产品服务线',
              url: '/Products/ProductDetails',
              ErMenu: [
                { name: '全过程工程咨询', url: '/Products/ProductDetails/WholeProcess' },
                { name: '投资咨询', url: '/Products/ProductDetails/InvestmentConsultation' },
                { name: '工程设计', url: '/Products/ProductDetails/EngineeringDesign' },
                { name: '采购与招标代理', url: '/Products/ProductDetails/Tendering' },
                { name: '工程造价咨询', url: '/Products/ProductDetails/Cost' },
                { name: '项目风险管控', url: '/Products/ProductDetails/Risk' },
                { name: '工程财务咨询', url: '/Products/ProductDetails/Finance' },
              ]
            },
            {
              name: '工程管理科技生态圈',
              url: '/Products/EcosphereDetails',
              ErMenu: [
                { name: 'BIM技术', url: '/Products/EcosphereDetails/Technology' },
                { name: 'BIM应用咨询', url: '/Products/EcosphereDetails/BIM' },
                { name: '建设工程大数据', url: '/Products/EcosphereDetails/Information' },
                { name: '工程造价标准化作业', url: '/Products/EcosphereDetails/Metering' },
                { name: '智慧造价机器人', url: '/Products/EcosphereDetails/Robot' },
                { name: '信息系统', url: '/Products/EcosphereDetails/Development' },
                { name: '互联网', url: '/Products/EcosphereDetails/Platform' },
                { name: '知识分享', url: '/Products/EcosphereDetails/Train' },
              ]
            }
            ,
            {
              name: '立足中国 走向世界',
              url: '/Products/World',
              ErMenu: [
                { name: '国际业务', url: '/Products/World/International' },
              ]
            }
          ]
        },
        {
          name: '携手青矩',
          url: '/Join',
          ErMenu: [
            { name: '商务合作', url: '/Join/Cooperation' },
            { name: '工作机会', url: '/Join/Recruit' },
            { name: '专家征集', url: 'https://m.greetec.com/expert-db/', external: true }
          ]
        },
        {
          name: '洞察&资讯',
          url: '/News',
          ErMenu: [
            { name: '公司动态', url: '/Introduction/CompanyNews' },
            { name: '热点聚焦', url: '/News/Industry' },
            { name: '青矩洞察', url: '/News/Policy' },
          ]
        },
        {
          name: '投诉和建议',
          url: '/Feedback'
        },
        {
          name: '联系我们',
          url: '/ContactUs'
        },
        {
          name: '投资者关系',
          url: '/Investor'
        }

      ],
    }
  }
  componentDidMount() {
    const $ = window.$
    $('.menu').on('touchend', () => {
      $('.rightside-menu').addClass('active')
      $('body').addClass('modal-open')
    })
    $('.left-modal').on('touchend', () => {
      $('.rightside-menu').removeClass('active')
      $('body').removeClass('modal-open')
    })
    $('.rightside-menu .right-content').on('touchstart', '.channel-item-title', function () {
      $(this).toggleClass('active')
    })
  }
  render() {
    return (
      <header className="App-header">
        <div className="top">
          <Link to="/" className="logo">青矩技术</Link>
          <i className="menu"></i>
        </div>
        <div className="rightside-menu">
          <div className="left-modal"></div>
          <div className="right-content">
            <SideMenu menuList={this.state.menuList} history={this.props.history} />
          </div>
        </div>
      </header>
    );
  }
}
